import React from 'react';
import PieChart, {
    Legend,
    Series,
    Tooltip,
    Label,
    Connector,
} from 'devextreme-react/pie-chart';
import { Size } from "devextreme-react/vector-map";
import { MyContext } from '../../../../context';

class Doughnut extends React.Component {
    static contextType = MyContext
    render() {
        let data = this.props.data

        if ((this.props.kpi === "OverallComplianceRate" || this.props.kpi === "CaseComplianceRate")
            && this.props.data !== undefined && this.props.data.length > 0) {
            data = [
                { value: this.props.data[0].noHit, args: this.context.getTranslation("compliance", "notCompliant") },
                { value: this.props.data[0].hit, args: this.context.getTranslation("compliance", "compliant") },
            ]
        }
        if ((this.props.kpi === "OverallEscalationRate" || this.props.kpi === "CaseEscalationRate")
            && this.props.data !== undefined && this.props.data.length > 0) {
            data = [
                { value: this.props.data[0].noHit, args: this.context.getTranslation("compliance", "notEscalated") },
                { value: this.props.data[0].hit, args: this.context.getTranslation("compliance", "escalated") },
            ]
        }
        return (
            <PieChart
                id="pie"
                type="doughnut"
                ref={this.props.reference}
                palette={this.props.palette}
                dataSource={data}
                centerRender={this.TooltipTemplate}
            >
                <Series argumentField="args" valueField="value">
                    <Label visible={true} >
                        <Connector visible={true} />
                    </Label>
                </Series>
                <Legend
                    margin={0}
                    horizontalAlignment="center"
                    verticalAlignment="bot"
                />
                <Tooltip enabled={true} customizeTooltip={this.customizeTooltip}>

                </Tooltip>


                <Size
                    height={this.props.size.height}
                    width={this.props.size.width}
                />
            </PieChart>
        );
    }

    customizeTooltip(arg) {
        return {
            text: `${arg.valueText} - ${(arg.percent * 100).toFixed(2)}%`
        };
    }

    TooltipTemplate = (pieChart) => {
        return (
            <svg x={"-100"} y={"-100"}>
                <circle cx="100" cy="100" r={pieChart.getInnerRadius() - 6} fill="#eee"></circle>
                <text textAnchor="middle" x="100" y="87" style={{ fontSize: 18, fill: '#494949' }}>
                    <tspan x="100" dy="20px" style={{ fontWeight: 600 }}>{this.props.labelCenter}</tspan>
                </text>
            </svg>
        );
    }
}



export default Doughnut;